<template>
  <nav class="site-nav" aria-label="Primary navigation" @keydown.esc="closeMenus">
    <div class="nav-inner">
      <router-link class="brand" :to="{ name: locale === 'id' ? 'wa-gb-id' : 'gb-whatsapp-apk' }">
        <img src="@/assets/logo.webp" alt="GB WhatsApp logo">
        <span>AndroidWaves</span>
      </router-link>

      <button class="menu-toggle" type="button" aria-label="Toggle navigation" @click="toggleMenu">
        <img v-if="!isMenuOpen" src="@/assets/menu.svg" alt="">
        <img v-else src="@/assets/xmark-black.svg" alt="">
      </button>

      <ul class="nav-links" :class="{ open: isMenuOpen }">
        <li>
          <router-link :to="{ name: locale === 'id' ? 'wa-gb-id' : 'gb-whatsapp-apk' }" @click.native="closeMenus">
            {{ locale === 'id' ? 'WA GB APK' : 'GB WhatsApp APK' }}
          </router-link>
        </li>
        <li>
          <router-link :to="{ name: 'old-versions' }" @click.native="closeMenus">
            {{ locale === 'id' ? 'Versi Lama' : 'Old Versions' }}
          </router-link>
        </li>
        <li class="nav-dropdown" :class="{ open: isModsOpen }" @mouseenter="onModsEnter" @mouseleave="onModsLeave">
          <button
            class="nav-dropdown__trigger"
            type="button"
            :aria-expanded="isModsOpen ? 'true' : 'false'"
            aria-haspopup="true"
            @click="toggleMods"
          >
            <span>WhatsApp MODs</span>
            <svg class="nav-dropdown__caret" viewBox="0 0 12 8" aria-hidden="true">
              <path d="M1.2 1.5 6 6.1l4.8-4.6" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
          </button>
          <ul class="nav-dropdown__menu" role="menu">
            <li v-for="mod in modItems" :key="mod.id" role="none">
              <router-link
                role="menuitem"
                :to="{ name: mod.route }"
                @click.native="closeMenus"
              >
                <img :src="mod.icon" :alt="''" width="22" height="22">
                <span>{{ mod.name }}</span>
              </router-link>
            </li>
            <li class="nav-dropdown__all" role="none">
              <router-link role="menuitem" :to="{ name: 'whatsapp-mods' }" @click.native="closeMenus">
                View all WhatsApp MODs
              </router-link>
            </li>
          </ul>
        </li>
        <li>
          <router-link :to="{ name: 'blogs' }" @click.native="closeMenus">Blogs</router-link>
        </li>
        <li>
          <router-link
            class="download-link"
            :to="{ name: locale === 'id' ? 'wa-gb-id' : 'gb-whatsapp-apk', hash: '#installation-guide' }"
            @click.native="closeMenus"
          >
            {{ locale === 'id' ? 'Unduh' : 'Download' }}
          </router-link>
        </li>
        <li class="lang-switch">
          <router-link :to="{ name: 'gb-whatsapp-apk' }" :class="{ active: locale === 'en' }" @click.native="closeMenus">English</router-link>
          <router-link :to="{ name: 'wa-gb-id' }" :class="{ active: locale === 'id' }" @click.native="closeMenus">Indonesia</router-link>
        </li>
      </ul>
    </div>
  </nav>
</template>

<script>
import { MODS } from '@/content/mods';

export default {
  name: 'HeadNav',
  props: {
    selectedLanguage: {
      type: String,
      default: 'en',
    },
    page: {
      type: String,
      default: 'home',
    },
  },
  data() {
    return {
      isMenuOpen: false,
      isModsOpen: false,
      modsLeaveTimer: null,
      modItems: [MODS.gb, MODS.fm, MODS.yo, MODS.blue, MODS.og, MODS.aero],
    };
  },
  computed: {
    locale() {
      return this.$route.meta.locale || this.selectedLanguage || 'en';
    },
  },
  watch: {
    $route() {
      this.closeMenus();
    },
  },
  mounted() {
    document.addEventListener('click', this.onDocClick);
  },
  beforeDestroy() {
    document.removeEventListener('click', this.onDocClick);
    this.clearModsLeaveTimer();
  },
  methods: {
    toggleMenu() {
      this.isMenuOpen = !this.isMenuOpen;
      if (!this.isMenuOpen) {
        this.isModsOpen = false;
      }
    },
    toggleMods() {
      this.isModsOpen = !this.isModsOpen;
    },
    clearModsLeaveTimer() {
      if (this.modsLeaveTimer) {
        clearTimeout(this.modsLeaveTimer);
        this.modsLeaveTimer = null;
      }
    },
    onModsEnter() {
      this.clearModsLeaveTimer();
      if (window.matchMedia('(min-width: 981px)').matches) {
        this.isModsOpen = true;
      }
    },
    onModsLeave() {
      if (!window.matchMedia('(min-width: 981px)').matches) {
        return;
      }
      this.clearModsLeaveTimer();
      this.modsLeaveTimer = setTimeout(() => {
        this.isModsOpen = false;
        this.modsLeaveTimer = null;
      }, 160);
    },
    closeMenus() {
      this.clearModsLeaveTimer();
      this.isMenuOpen = false;
      this.isModsOpen = false;
    },
    onDocClick(event) {
      if (!this.$el.contains(event.target)) {
        this.closeMenus();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.site-nav {
  --aw-font-body: -apple-system, system-ui, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol";
  --aw-font-heading: -apple-system, system-ui, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol";
  position: sticky;
  top: 0;
  z-index: 1000;
  border-bottom: 1px solid #d8e5dd;
  background: rgba(255, 255, 255, 0.96);
  backdrop-filter: blur(10px);
  font-family: var(--aw-font-body);
  font-size: 18px;
  line-height: 1.65;
  -webkit-font-smoothing: antialiased;
}

.nav-inner {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: min(1180px, calc(100% - 40px));
  min-height: 72px;
  margin: 0 auto;
}

.brand {
  display: inline-flex;
  align-items: center;
  gap: 12px;
  color: #18231f;
  font-family: var(--aw-font-heading);
  font-size: 20px;
  font-weight: 400;
  line-height: 1.2;
  text-decoration: none;
  white-space: nowrap;
}

.brand img {
  width: 42px;
  height: 42px;
  object-fit: contain;
}

.nav-links {
  display: flex;
  align-items: center;
  gap: 6px;
  margin: 0 !important;
  margin-block: 0 !important;
  margin-inline: 0 !important;
  padding: 0;
  list-style: none;
}

.nav-links li {
  display: inline-flex;
  align-items: center;
  margin: 0;
  padding: 0;
  list-style: none;
}

.nav-links li::before,
.nav-links li::after {
  content: none;
  display: none;
}

.nav-links a,
.nav-dropdown__trigger {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  min-height: 42px;
  padding: 0 9px;
  border: 0;
  border-radius: 6px;
  background: transparent;
  color: #33443d;
  font-family: var(--aw-font-heading);
  font-size: 14px;
  font-weight: 400;
  line-height: 1.2;
  text-decoration: none;
  white-space: nowrap;
  cursor: pointer;
}

.nav-links a:hover,
.nav-links .router-link-exact-active,
.nav-dropdown.open .nav-dropdown__trigger,
.lang-switch a.active {
  color: #0b7a5a;
}

.nav-dropdown {
  position: relative;
}

.nav-dropdown__caret {
  width: 10px;
  height: 7px;
  flex: 0 0 auto;
  transition: transform 0.18s ease;
}

.nav-dropdown.open .nav-dropdown__caret {
  transform: rotate(180deg);
}

.nav-dropdown__menu {
  display: none;
  position: absolute;
  top: calc(100% + 6px);
  left: 0;
  min-width: 220px;
  margin: 0;
  padding: 8px;
  list-style: none;
  border: 1px solid #dce5df;
  border-radius: 12px;
  background: #fff;
  box-shadow: 0 14px 32px rgba(15, 23, 42, 0.12);
  z-index: 20;
}

.nav-dropdown__menu::before {
  content: '';
  position: absolute;
  left: 0;
  right: 0;
  bottom: 100%;
  height: 14px;
}

.nav-dropdown.open .nav-dropdown__menu {
  display: block;
}

.nav-dropdown__menu li {
  display: block;
  width: 100%;
}

.nav-dropdown__menu a {
  display: flex;
  width: 100%;
  justify-content: flex-start;
  gap: 10px;
  min-height: 40px;
  padding: 0 10px;
  border-radius: 8px;
  color: #33443d;
  font-size: 14px;
}

.nav-dropdown__menu a:hover,
.nav-dropdown__menu .router-link-exact-active {
  background: #eef8f2;
  color: #0b7a5a;
}

.nav-dropdown__menu img {
  width: 22px;
  height: 22px;
  object-fit: contain;
  border-radius: 5px;
  flex: 0 0 auto;
}

.nav-dropdown__all {
  margin-top: 4px;
  padding-top: 4px;
  border-top: 1px solid #e8efe9;
}

.nav-dropdown__all a {
  color: #0b7a5a;
  font-weight: 600;
}

.download-link {
  background: #18231f;
  color: #fff !important;
  font-weight: 700;
}

.lang-switch {
  display: inline-flex;
  margin-left: 6px;
  border: 1px solid #d8e5dd;
  border-radius: 8px;
  overflow: hidden;
}

.lang-switch a {
  min-height: 36px;
  padding: 0 10px;
  border-radius: 0;
  font-size: 14px;
}

.lang-switch a.active {
  background: #e8f7ef;
}

.menu-toggle {
  display: none;
  width: 42px;
  height: 42px;
  align-items: center;
  justify-content: center;
  border: 1px solid #d8e5dd;
  border-radius: 6px;
  background: #fff;
  cursor: pointer;
}

.menu-toggle img {
  width: 22px;
  height: 22px;
}

@media (max-width: 980px) {
  .nav-inner {
    width: calc(100% - 28px);
    min-height: 64px;
  }

  .menu-toggle {
    display: inline-flex;
  }

  .nav-links {
    display: none;
    position: absolute;
    top: 64px;
    right: 14px;
    left: 14px;
    flex-direction: column;
    align-items: stretch;
    padding: 10px;
    border: 1px solid #d8e5dd;
    border-radius: 8px;
    background: #fff;
    box-shadow: 0 18px 42px rgba(15, 23, 42, 0.14);
  }

  .nav-links.open {
    display: flex;
  }

  .nav-links a,
  .nav-dropdown__trigger {
    width: 100%;
    justify-content: flex-start;
  }

  .nav-dropdown {
    display: block;
    width: 100%;
  }

  .nav-dropdown__menu {
    position: static;
    display: none;
    min-width: 0;
    margin-top: 4px;
    box-shadow: none;
  }

  .nav-dropdown.open .nav-dropdown__menu {
    display: block;
  }
}
</style>
